module.exports = __webpack_public_path__ + "statics/img/2.ca1e256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/2.png
// module id = 6frX
// module chunks = 1